export default "{\n    \"label\": \"{{name}}\",\n    \"label_0\": \"Instalación\",\n    \"label_plural\": \"{{count}} instalaciones\"\n}\n"